import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaimentChekoutForm from './StripePaimentChekoutForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function QuoteElementStripePaiment(props) {
  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret: props.paymentLink }}
    >
      <StripePaimentChekoutForm />
    </Elements>
  );
}

export default QuoteElementStripePaiment;
